// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-file-preview {
  display: inline-block;
  height: 32px;
  width: 32px;
}
.fi-file-preview .fa {
  color: var(--fi-color-light);
}
.fi-file-preview * {
  vertical-align: middle;
}
.fi-file-preview .preview-icon,
.fi-file-preview .preview-image {
  width: 100%;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}
.fi-file-preview .preview-image {
  background-size: cover;
  border: 1px solid var(--fi-border-color-dark);
  border-radius: 4px;
}
.fi-file-preview .preview-icon {
  vertical-align: middle;
  border: 1px solid transparent;
}
.fi-file-preview .preview-icon:before {
  vertical-align: middle;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/file-preview/file-preview.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,YAAA;EACA,WAAA;AACJ;AACI;EACI,4BAAA;AACR;AAEI;EACI,sBAAA;AAAR;AAGI;;EAEI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AADR;AAII;EACI,sBAAA;EACA,6CAAA;EACA,kBAAA;AAFR;AAKI;EACI,sBAAA;EACA,6BAAA;AAHR;AAKQ;EACI,sBAAA;EACA,gBAAA;AAHZ","sourcesContent":[".fi-file-preview {\r\n    display: inline-block;\r\n    height: 32px;\r\n    width: 32px;\r\n\r\n    .fa {\r\n        color: var(--fi-color-light);\r\n    }\r\n\r\n    * {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .preview-icon,\r\n    .preview-image {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .preview-image {\r\n        background-size: cover;\r\n        border: 1px solid var(--fi-border-color-dark);\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .preview-icon {\r\n        vertical-align: middle;\r\n        border: 1px solid transparent;\r\n\r\n        &:before {\r\n            vertical-align: middle;\r\n            line-height: 1.4;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
